<kh-img path="chat-button.png" class="ChatIconFloating" (click)="viewChat()"></kh-img>